let switchWidth = 1199;

if ($('[data-product-slider]').length) {
    swiperProduct();
}


function swiperProduct() {
    let slider = '[data-product-slider]';
    let thumbsId = 'product-slider-thumbs';
    let clrTimeOut;
    let sliderProduct = null;
    let thumbsSlider = null;
    let options = {
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        slidesPerView: 1,
        thumbs: {
            swiper: thumbsSlider
        }
    };
    let thumbsOptions = {
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        slidesPerView: 3.2,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        thumbs: {
            swiper: sliderProduct
        },
        freeMode: {
            enabled: true
        },
        mousewheel: {
            enabled: true,
            forceToAxis: true,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2.02,
            },
            768: {
                slidesPerView: 3.2,
            }
        }
    };

    function thumbsCarousel() {
        thumbsSlider = '<div id="' + thumbsId + '" class="c-slider__thumbs"><div class="c-slider__thumbs__swiper-wrapper swiper-wrapper">';
        $(slider).find('img').each(function (index) {

            thumbsSlider += '<div class="c-slider__thumbs__swiper-slide swiper-slide"><a href="#" class="c-slider__thumbs__lnk c-slider__open-link" data-index="' + index + '"><img loading="lazy" src="' + $(this).attr('src') + '" alt="' + $(this).attr('alt') + '" class="c-slider__img"></a></div>';
        });
        thumbsSlider += '</div><div class="c-slider__thumbs__swiper-scrollbar swiper-scrollbar"></div></div>';
        return thumbsSlider;

    }

    thumbsCarousel()

    function sliderInitReinit() {
        /*if ($(window).width() > switchWidth) {
            if (thumbsSlider && sliderProduct) {
                $('#'+thumbsId).remove();
                sliderProduct.destroy( true, true );
                thumbsSlider.destroy( true, true );
                thumbsSlider = null;
                sliderProduct = null;
            }
        } else {*/
        if (sliderProduct === null && !$('#' + thumbsId).length) {
            $(slider).after(thumbsCarousel())
            thumbsSlider = new Swiper('#' + thumbsId, {
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                slidesPerView: 3.2,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                thumbs: {
                    swiper: sliderProduct
                },
                freeMode: {
                    enabled: true
                },
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                },
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 2.04,
                        spaceBetween: 8
                    },
                    768: {
                        slidesPerView: 3.2,
                        spaceBetween: 8
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 31
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    }
                }
            });
            sliderProduct = new Swiper(slider, {
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                slidesPerView: 'auto',
                thumbs: {
                    swiper: thumbsSlider
                }
            });
            // sliderProduct.controller.control = thumbsSlider;
            // thumbsSlider.controller.control =  sliderProduct;
        }
        //}

    }

    sliderInitReinit()
    $(window).resize(function () {
        clearTimeout(clrTimeOut);
        clrTimeOut = setTimeout(function () {
            sliderInitReinit()
        }, 200);
    });
}
